import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Header = () => {
    return (
        <header className="app-header">
            <div className="header-container">
                <div className="logo">
                    <img src="/images/header-midnight.jpg" alt="Logo" />
                </div>
                <div className="search-bar">
                    <input type="text" placeholder="Search blogs..." />
                    <button onClick={()=> {toast.info("Search feature is under development. Please try later...")}}>Search</button>
                </div>
                <nav>
                    <ul className="nav-list">
                        <li className="nav-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/my-blogs">My Blogs</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/login">Login</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/signup">Signup</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/createblog">Create Blog</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/blogs">All Blogs</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/learn">Learn</Link>
                        </li>
                        <li className="nav-item"><Link to="/logout">Logout</Link></li>
                    </ul>
                </nav>
                <div className="user-profile">
                    <div className="user-avatar">
                        <img src="/images/profile-avatar.png" alt="User Profile" />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
